module.exports = __webpack_public_path__ + "img/pro-xtIcon7.2d8f55f3.png";